"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeSegmentRow = void 0;

var _context = require("../../context");

var _layout = require("../../layout");

var TimeSegmentRow = (0, _context.styledWithTheme)(_layout.Row)(function (_ref) {
  var selectors = _ref.theme.selectors;
  return {
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: selectors.fontSize('T300'),
    fontFamily: selectors.fontFamily('primary')
  };
});
exports.TimeSegmentRow = TimeSegmentRow;